import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MarketPriceState } from './marketprice.state';
import { marketPriceFeatureKey } from './marketprice.reducers';

export const selectMarketPriceState = createFeatureSelector<MarketPriceState>(marketPriceFeatureKey);

export const selectMarketPrice = createSelector(selectMarketPriceState, (state: MarketPriceState) => state);